module.exports = __webpack_public_path__ + "occupancy.png?8486ff6163b6da1ffd130e2786be57e5";